import { Nudge } from './types';

const FD_DEEPLINK =
  'redirectToNativeApp.jsp?a=jfs_explore_clp?id=In_FD?utm_source=Nudges_Default&utm_medium=JFS_FD&utm_campaign=TMF_FD&i=jiofinance://in.jfs.jiofinance/jfs_explore_clp?id=In_FD?utm_source=Nudges_Default&utm_medium=JFS_FD&utm_campaign=TMF_FD';
const SILVER_DEEPLINK =
  'redirectToNativeApp.jsp?a=jfs_explore_pdp?id=NW01?utm_source=Nudges_Default&utm_medium=JFS_Silver&utm_campaign=TMF_Silver&i=jiofinance://in.jfs.jiofinance/jfs_explore_pdp?id=NW01?utm_source=Nudges_Default&utm_medium=JFS_Silver&utm_campaign=TMF_Silver';
const GOLD_DEEPLINK =
  'redirectToNativeApp.jsp?a=jfs_explore_pdp?id=SafeGold01?utm_source=Nudges_Default&utm_medium=JFS_Gold&utm_campaign=TMF_Gold&i=jiofinance://in.jfs.jiofinance/jfs_explore_pdp?id=SafeGold01?utm_source=Nudges_Default&utm_medium=JFS_Gold&utm_campaign=TMF_Gold';
const CC_DEEPLINK =
  'redirectToNativeApp.jsp?a=jfs_explore?tabDirectionDeepLink=6?utm_source=Nudges_Default&utm_medium=JFS_CC&utm_campaign=TMF_CC&i=jiofinance://in.jfs.jiofinance/jfs_explore?tabDirectionDeepLink=6?utm_source=Nudges_Default&utm_medium=JFS_CC&utm_campaign=TMF_CC';

const DEFAULT_NUDGE_LOADING_TEXT = 'Please wait while we redirect you';

// category is the event suffix, e.g. JFS_NUDGE_RENDERED_Gold_Default
// header renders in black, body in orange (NudgeCard "Content" type);
// nudgeText is the entry point copy shown on the dashboard nudge deck
export const DEFAULT_NUDGES: Nudge[] = [
  {
    nudgeId: 'FD_Default',
    title: 'Insights',
    category: 'FD_Default',
    body: {
      type: 'Content',
      header: "Got some money lying around? Don't let it sit idle.",
      body: 'Set up quick FDs and earn up to 8.5% p.a.',
      nudgeText: 'Still letting your bank balance sit idle?',
      appLink: FD_DEEPLINK,
      appText: 'Earn up to 8.5%',
      enableAppLinkLoading: 'true',
      loadingText: DEFAULT_NUDGE_LOADING_TEXT,
    },
  },
  {
    nudgeId: 'Silver_Default',
    title: 'Insights',
    category: 'Silver_Default',
    body: {
      type: 'Content',
      header: 'Always wanted to own silver but never got around to it?',
      body: 'Start small, grow it gram by gram, and get 1% extra silver as a Jio Finance+ subscriber.',
      nudgeText: 'Buying silver just got super easy',
      appLink: SILVER_DEEPLINK,
      appText: 'Buy silver now',
      enableAppLinkLoading: 'true',
      loadingText: DEFAULT_NUDGE_LOADING_TEXT,
    },
  },
  {
    nudgeId: 'Gold_Default',
    title: 'Insights',
    category: 'Gold_Default',
    body: {
      type: 'Content',
      header: 'You can start your 24K gold journey with just ₹10! Yes, really.',
      body: 'Start small, shine big, and get 1% extra gold as a Jio Finance+ subscriber.',
      nudgeText: 'Real 24K gold starting at just ₹10',
      appLink: GOLD_DEEPLINK,
      appText: 'Buy gold now',
      enableAppLinkLoading: 'true',
      loadingText: DEFAULT_NUDGE_LOADING_TEXT,
    },
  },
  {
    nudgeId: 'CC_Default',
    title: 'Insights',
    category: 'CC_Default',
    body: {
      type: 'Content',
      header:
        'Explore credit cards with zero joining fees, welcome perks, and cashback on eligible spends.',
      nudgeText: 'Turn your everyday spends into rewarding moments.',
      appLink: CC_DEEPLINK,
      appText: 'Find your card',
      enableAppLinkLoading: 'true',
      loadingText: DEFAULT_NUDGE_LOADING_TEXT,
    },
  },
];

export const isDefaultNudge = (nudge: Nudge): boolean =>
  DEFAULT_NUDGES.some(
    (defaultNudge) => defaultNudge.nudgeId === nudge.nudgeId
  );

const hasRenderableContent = (nudge: Nudge): boolean => {
  const body = nudge?.body;
  if (!body || typeof body === 'string') return false;

  return Boolean(
    body.header ||
    body.body ||
    body.nudgeText ||
    (body as any).footer ||
    (body as any).bulletsPoint1
  );
};

const DEFAULT_NUDGES_SEEN_KEY = 'jfsDefaultNudgesSeen';

export const hasSeenDefaultNudges = (): boolean => {
  try {
    return localStorage.getItem(DEFAULT_NUDGES_SEEN_KEY) === 'true';
  } catch {
    return false;
  }
};

export const markDefaultNudgesSeen = () => {
  try {
    localStorage.setItem(DEFAULT_NUDGES_SEEN_KEY, 'true');
  } catch {
    // Ignore localStorage errors
  }
};

// First visit: defaults on top. Once seen, dynamic nudges go on top.
export const composeNudgeStackData = (
  dynamicNudges?: Nudge[],
  defaultsFirst = true
): Nudge[] => {
  const dynamic = (dynamicNudges ?? []).filter(hasRenderableContent);
  return defaultsFirst
    ? [...DEFAULT_NUDGES, ...dynamic]
    : [...dynamic, ...DEFAULT_NUDGES];
};

// Rotate so the given nudge is first, keeping the rest in order after it
export const rotateNudgesToId = (nudges: Nudge[], nudgeId?: string): Nudge[] => {
  const index = nudgeId
    ? nudges.findIndex((nudge) => nudge.nudgeId === nudgeId)
    : -1;
  if (index <= 0) return nudges;
  return [...nudges.slice(index), ...nudges.slice(0, index)];
};
